import getCities from "@component_path/lib/call_api/master_data/cities";

const state = {
  prefectures: [],
  cities: [],
  positionTypes: [],
  employmentTypes: [],
  agentSelectionAuctions: [],
  wishfulTimes: [],
  birthYears: []
};

const getters = {
  featuredAgentSelectionAuctions: state => endNumber =>
    state.agentSelectionAuctions.slice(0, endNumber),
  additionalAgentSelectionAuctions: state => beginIdx =>
    state.agentSelectionAuctions.slice(beginIdx)
};

const actions = {
  initMasterData({ dispatch }, master_data) {
    dispatch("setPrefectures", master_data.prefectures);
    dispatch("setPositionTypes", master_data.position_types);
    dispatch("setEmploymentTypes", master_data.employment_types);
    dispatch("setWishfulTimes", master_data.wishful_times || []);
    dispatch("setBirthYears", master_data.birth_years || []);
  },
  // slide_form_common_module/store/masterDataにあるデータ変換と処理内容が同じのため
  // 切り出して共通化したい
  setPrefectures({ commit }, prefectures) {
    const formattedPrefectures = prefectures.map(prefecture => ({
      value: prefecture.id,
      label: prefecture.name
    }));
    commit("SET_PREFECTURES", formattedPrefectures);
  },
  setCities({ commit }, cities) {
    const formattedCities = Object.keys(cities).map(key => {
      const city = cities[key];
      return { id: city.id, value: city.name, label: city.name };
    });
    commit("SET_CITIES", formattedCities);
  },
  setPositionTypes({ commit }, position_types) {
    const formattedPositionTypes = position_types.map(position_type => ({
      value: position_type.code,
      label: position_type.name
    }));
    commit("SET_POSITION_TYPES", formattedPositionTypes);
  },
  setEmploymentTypes({ commit }, employment_types) {
    const formattedEmploymentTypes = employment_types.map(employment_type => ({
      value: employment_type.code,
      label: employment_type.name
    }));
    commit("SET_EMPLOYMENT_TYPES", formattedEmploymentTypes);
  },
  setWishfulTimes({ commit }, wishful_times) {
    const formattedWishfulTimes = wishful_times.map(wishful_time => ({
      value: wishful_time.code,
      label: wishful_time.name
    }));
    commit("SET_WISHFUL_TIMES", formattedWishfulTimes);
  },
  setBirthYears({ commit }, birthYears) {
    const formattedBirthYears = birthYears.map(birth_year => ({
      value: birth_year.value,
      label: birth_year.text
    }));
    commit("SET_BIRTH_YEARS", formattedBirthYears);
  },
  setAgentSelectionAuctions({ commit }, value) {
    commit("SET_AGENT_SELECTION_AUCTIONS", value);
  },
  async fetchCitiesFromExternal({ dispatch }, prefectureId) {
    if (prefectureId) {
      await getCities(prefectureId, cities => dispatch("setCities", cities));
    } else {
      dispatch("setCities", []);
    }
  }
};

const mutations = {
  SET_PREFECTURES(state, value) {
    state.prefectures = value;
  },
  SET_CITIES(state, value) {
    state.cities = value;
  },
  SET_POSITION_TYPES(state, value) {
    state.positionTypes = value;
  },
  SET_EMPLOYMENT_TYPES(state, value) {
    state.employmentTypes = value;
  },
  SET_WISHFUL_TIMES(state, wishful_times) {
    state.wishfulTimes = wishful_times;
  },
  SET_BIRTH_YEARS(state, birthYears) {
    state.birthYears = birthYears;
  },
  SET_AGENT_SELECTION_AUCTIONS(state, value) {
    state.agentSelectionAuctions = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};
